import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InbOrd03Actions, { InbOrd03Types } from '../Stores/InbOrd03/Actions';

const getAppStore = state => state.app;

export function* inbOrd03FetchInbOrd03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InbOrd03Actions.inbOrd03FetchInbOrd03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `inbOrd/indexProcess/INB_ORD_03/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InbOrd03Actions.inbOrd03FetchInbOrd03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd03Actions.inbOrd03FetchInbOrd03Loading(false));
  }
}

export function* inbOrd03CreateInbOrd03({ hdrIds }) {
  try {
    yield put(InbOrd03Actions.inbOrd03CreateInbOrd03Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `inbOrd/createProcess/INB_ORD_03`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd03Actions.inbOrd03CreateInbOrd03Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd03Actions.inbOrd03CreateInbOrd03Loading(false));
  }
}

export function* inbOrd03GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspAdvShipDetail/update/${hdrId}`));
}

export function* inbOrd03NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspAdvShipDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(InbOrd03Types.INB_ORD03_FETCH_INB_ORD03, inbOrd03FetchInbOrd03),
  takeLatest(InbOrd03Types.INB_ORD03_CREATE_INB_ORD03, inbOrd03CreateInbOrd03),
  takeLatest(InbOrd03Types.INB_ORD03_GO_TO_DOCUMENT, inbOrd03GoToDocument),
  takeLatest(InbOrd03Types.INB_ORD03_NEW_DOCUMENT, inbOrd03NewDocument)
];
